webpackJsonp([5],{

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toasted__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_tinymce__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_tinymce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_tinymce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_the_mask__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_i18n__ = __webpack_require__(15);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import 'babel-polyfill';










__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_tinymce___default.a);
var Credenciamento = function Credenciamento() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 57));
};

var CertificadosMain = function CertificadosMain() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 56));
};
var CertificadoEditor = function CertificadoEditor() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 55));
};

var LoaderFullPage = function LoaderFullPage() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 67));
};
var ListaParticipantes = function ListaParticipantes() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 66));
};
var ListaDados = function ListaDados() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 58));
};
var VodalNovoParticipante = function VodalNovoParticipante() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 68));
};

var AnaisHeader = function AnaisHeader() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 61));
};
var AnaisMain = function AnaisMain() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 62));
};
var AnaisAutores = function AnaisAutores() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 60));
};
var AnaisAutor = function AnaisAutor() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 59));
};
var AnaisTrabalhos = function AnaisTrabalhos() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 65));
};
var AnaisTrabalho = function AnaisTrabalho() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 63));
};
var AnaisTrabalhoRow = function AnaisTrabalhoRow() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 64));
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_toasted___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_i18n__["a" /* default */]);

if (lang == "pt-br") {
  lang = "pt_br";
}

var i18n = new __WEBPACK_IMPORTED_MODULE_9_vue_i18n__["a" /* default */]({
  locale: lang, // set locale
  fallbackLocale: 'pt_br',
  fallbackRoot: true,
  silentTranslationWarn: true
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.lang = lang;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('upper', function (value) {
  return value.toUpperCase();
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('plural', function (value, singular, plur) {
  return value == 1 ? singular : plur;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('moment', function (date) {
  return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('DD/MM HH:mm');
});

window.moment = __WEBPACK_IMPORTED_MODULE_5_moment___default.a;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('moeda', function (value) {
  if (value == 0) return "Gratuito";
  return "R$ " + parseFloat(value).toFixed(2).replace(".", ",");;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('moment', function (date) {
  return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date * 1000).format('DD/MM/YY');
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('diaHora', function (date) {
  return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date * 1000).format('DD/MM/YY H:mm');
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('mes', function (date) {
  return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date * 1000).format('MMM');
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('ano', function (date) {
  return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date * 1000).format('YYYY');
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('dia', function (date) {
  return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date * 1000).format('DD');
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('tempo', function (date) {
  return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date * 1000).format('H:mm');
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('CertificadosMain', CertificadosMain);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('CertificadoEditor', CertificadoEditor);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('Credenciamento', Credenciamento);

// lista de participantes
// vue the mask é utilizado na lista de participantes
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('ListaParticipantes', ListaParticipantes);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('LoaderFullPage', LoaderFullPage);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('ListaDados', ListaDados);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('VodalNovoParticipante', VodalNovoParticipante);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('AnaisHeader', AnaisHeader);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('AnaisTrabalhoRow', AnaisTrabalhoRow);

var routerCertificados = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: [{ path: '/', component: CertificadosMain }, { path: '/novo', component: CertificadoEditor }, { path: '/:id', component: CertificadoEditor }]
});

var routerAnais = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: [{ path: '/autores/:pesquisa', component: AnaisAutores }, { path: '/autores', component: AnaisAutores }, { path: '/autor/:autor_id', component: AnaisAutor }, { path: '/trabalhos/:pesquisa', component: AnaisTrabalhos, name: 'trabalhos' }, { path: '/trabalhos', component: AnaisTrabalhos }, { path: '/trabalho/:trabalho_id', component: AnaisTrabalho }, { path: '/:page', component: AnaisMain }, { path: '/', component: AnaisMain }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

var newVue = [
// aqui temos um array
// de objetos que vão na função
// new Vue({...})
{ el: '#app' }, { el: '#app-certificados', router: routerCertificados }, { el: '#app-anais', router: routerAnais }];

newVue.forEach(function (obj) {
  return new __WEBPACK_IMPORTED_MODULE_1_vue__["default"](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ i18n: i18n }, obj));
});

window.Vue = __WEBPACK_IMPORTED_MODULE_1_vue__["default"];

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./pt-br": 12,
	"./pt-br.js": 12
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[44]);


// WEBPACK FOOTER //
// static/js/app.c680cca47bfafe7d14ba.js